module.exports = __webpack_public_path__ + "img/ic_standard_logo_normal.3389792.png";